// import axios from "axios";

// import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
// const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
// const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

// export default class AccountingLiabilitiesTLMService {
//   private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
//   public getAllCompanies(querySearch?: any): Promise<any> {
//     return new Promise<any>((resolve, reject) => {
//       axios
//         .post("/api/business/company?page=0&size=10000", querySearch)
//         .then((res) => {
//           resolve(res.data);
//         })
//         .catch((err) => {
//           reject(err);
//         });
//     });
//   }
// }

import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class AccountingLiabilitiesTLMService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company?page=0&size=10000", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public SearchTML(querySearch: any, cancelToken): Promise<any> {
    let url = "/api/business/track-debt/tlm/finan-period";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public excelTLM(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/track-debt/tlm/finan-period/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
